<template>
  <v-container>
    <v-overlay :absolute="absolute" :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col>
        <v-banner elevation="1">Grupos</v-banner>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-center">
          <v-text-field
            label="Buscar"
            placeholder="Grupo..."
            v-model="searchGroup"
            @keyup="filterGroups()"
          ></v-text-field>
        </div>
      </v-col>
      <v-col>
        <div class="text-center float-right">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                fab
                small
                icon
                @click="showNew()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-ungroup
                </v-icon>
              </v-btn>
            </template>
            <span>Agregar Grupo</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet elevation="1">
          <v-progress-linear
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-linear>
          <v-simple-table cols="auto" elevation="9">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    ID
                  </th>
                  <th class="text-center">
                    Nombre
                  </th>
                  <th class="text-center">
                    Descripción
                  </th>
                  <th class="text-center">
                    Opciones
                  </th>
                </tr>
              </thead>
              <template v-if="groups.length">
                <tbody>
                  <tr
                    class="text-center"
                    v-for="group in groups"
                    :key="group.id"
                  >
                    <td>{{ group.id }}</td>
                    <td>{{ group.name }}</td>
                    <td>{{ group.description }}</td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            fab
                            small
                            icon
                            @click="showDelete(group)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <div class="float-right pa-4">
                  No hay registros
                </div>
              </template>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogDelete" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Eliminar Grupo</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          ¿está seguro que desea eliminar el grupo {{ groupDelete.name }}?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogDelete = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="warning float-right"
            text
            @click="deleteGroup(groupDelete)"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNew" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Crear Grupo:</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-form v-model="validNew">
            <v-container>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-text-field
                    v-model="groupNew.name"
                    :rules="nameRules"
                    :counter="24"
                    label="Nombre"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8">
                  <v-text-field
                    v-model="groupNew.description"
                    label="Descripción"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogNew = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary float-right"
            text
            @click="saveGroupNew()"
            :disabled="!validNew"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="alertSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Config } from "../config";
export default {
  data() {
    return {
      loading: false,
      overlay: true,
      absolute: true,
      groupNew: {
        name: "",
        description: ""
      },
      groupDelete: {},
      dialogNew: false,
      validNew: false,
      alertSnackbar: false,
      snackbarText: "",
      groups: [],
      searchGroup: "",
      valid: false,
      show: false,
      nameRules: [
        v => !!v || "El nombre no puede estar vacío",
        v => v.length >= 4 || "El nombre debe ser mayor a 4 caracteres",
        v => v.length <= 25 || "El nombre debe ser menor a 24 caracteres"
      ],
      dialogDelete: false
    };
  },
  mounted() {
    this.getGroups();
  },
  computed: {},
  methods: {
    getGroups() {
      this.overlay = true;
      let url = Config.url + "/db/workgroups";
      this.axios
        .get(url)
        .then(res => {
          this.groups = res.data.workgroups;
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Error en servidor, falló al tratar de obtener lista de Grupos";
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showNew() {
      this.dialogNew = true;
    },
    showDelete(group) {
      this.dialogDelete = true;
      this.groupDelete = group;
    },
    deleteGroup(group) {
      this.overlay = true;
      this.dialogDelete = false;
      let url = Config.url + "/db/workgroup";
      let params = {
        id: group.id
      };
      this.axios
        .delete(url, { params: params })
        .then(res => {
          if (res.status == 200) {
            this.snackbarText = "Grupo eliminado exitosamente";
            this.alertSnackbar = true;
            this.getGroups();
          }
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Ocurrió un error al eliminar grupo, intente más tarde";
          this.alertSnackbar = true;
          this.getGroups();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveGroupNew() {
      this.overlay = true;
      this.dialogNew = false;
      let url = Config.url + "/db/workgroup";
      let params = this.groupNew;
      this.groupNew.id = parseInt(this.groupNew.id);
      this.axios
        .post(url, params)
        .then(res => {
          if (res.status == 201) {
            this.snackbarText = "Grupo guardado exitosamente";
            this.alertSnackbar = true;
            this.groupNew = {
              name: "",
              description: ""
            };
            this.getGroups();
          }
        })
        .catch(err => {
          if (err.response.status == 409) {
            this.snackbarText = `Groupo ${this.groupNew.name} ya existe`;
          } else {
            this.snackbarText =
              "Ocurrió un error al guardar grupo, es posible que ya exista un grupo con este horario/nombre";
          }
          this.alertSnackbar = true;
          this.getGroups();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    filterGroups() {
      this.loading = true;
      if (this.searchGroup != "") {
        let url = Config.url + "/db/workgroups";
        this.axios
          .get(url)
          .then(res => {
            this.groups = res.data.workgroups;
            let arrayFilterUsers = [];
            let searchGroup = this.searchGroup.toLowerCase();
            this.groups.map(item => {
              let name = item.name.toLowerCase();
              let description = item.description
                ? item.description.toLowerCase()
                : "";
              if (
                name.search(searchGroup) != -1 ||
                description.search(searchGroup) != -1
              ) {
                arrayFilterUsers.push(item);
              }
            });
            this.groups = arrayFilterUsers;
          })
          .catch(err => {
            console.log(err);
            this.snackbarText = "Ocurrió un error, intente más tarde";
            this.alertSnackbar = true;
          });
      } else {
        this.getGroups();
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
